import {
    FolderParentId,
    IFolderContainer,
} from '@components/ui-folder-tree/ui-folder-tree-state';
import { IFolder } from '@models';
import { VirtualScrollItemStatus } from '@uipath/angular/directives/ui-virtual-scroll-range-loader';

import keyBy from 'lodash-es/keyBy';

let nextFakeId = -1;
export function emptyFolderContainers(count: number): IFolderContainer[] {
    return Array(count).fill(0).map(() => ({ loading: VirtualScrollItemStatus.initial, fakeId: nextFakeId-- }));
}

export function patchContainers(folders: IFolder[], index: number, containers: IFolderContainer[]) {
    folders.forEach((folderData, i) => {
        containers[index + i].folderData = folderData;
        containers[index + i].loading = VirtualScrollItemStatus.loaded;
    });
}

export function getParents(containers: IFolderContainer[], folderId: number) {
    const idToNode = keyBy(containers, fc => fc.folderData ? fc.folderData.id : fc.fakeId);
    const result = [];
    while (true) {
        const container: IFolderContainer = idToNode[folderId];
        if (!container || !container.folderData || container.folderData.parentId == null) {
            break;
        }
        folderId = container.folderData!.parentId;
        result.push(idToNode[folderId].folderData!);
    }
    return result;
}

export function getParentIds(containers: IFolderContainer[], folderId: number) {
    return getParents(containers, folderId).map(p => p.id);
}

export function trimExpandedFolders(parentOf: Map<number, FolderParentId>) {
    return Array.from(parentOf.keys()).filter(folderId => {
        while (parentOf.has(folderId)) {
            folderId = parentOf.get(folderId)!;
        }
        return folderId === null;
    }).map(Number);
}


export function buildParentMap(ancestors: number[]) {
    ancestors = [...ancestors].reverse();
    return ancestors.reduce((parentMap, id, i) => {
        parentMap.set(id, ancestors[i + 1] || null);
        return parentMap;
    }, new Map<number, FolderParentId>());
}
